module.exports = __webpack_public_path__ + "media/images/undraw/reserve/resume_folder-a16341b0fcc54eda936fb734b06c4060.png";